export enum ScheduleInterface {
    EVERY_DAY = 'Every Day',
    EVERY_HOUR_AT_THE_HOUR = 'Every hour at the hour',
    EVERY_15_MINUTES = 'Every 15 minutes',
    EVERY_HOUR_AT_THE_MINUTE = 'Every hour at the {minutes} minute',
    EMPTY = ''
}
